<div class="navbar-content" *ngIf="sidebarState$ | async as sidebarState">
  <div class="row desktop-title" style="gap: 12px; align-items: center">
    <app-svg-loader url="company.svg"></app-svg-loader>
    <div class="heading-large">{{ userData?.merchantName }}</div>
  </div>

  <div class="mobile-title">
    <div class="heading-large">
      {{ sidebarState.activeParentMenuLabel || sidebarState.activeMenuLabel || 'Home' }}
    </div>
  </div>

  <div style="flex-grow: 1"></div>

  <div
    *ngIf="!hideHelpCenter"
    (click)="showHelpCenterDialog()"
    tabindex="0"
    (keydown.enter)="showHelpCenterDialog()"
    class="content-icon"
  >
    <app-svg-loader url="headset.svg" class="custom-icon"></app-svg-loader>
  </div>

  <div
    *ngIf="!hideNotification"
    (click)="openNotification()"
    tabindex="0"
    (keydown.enter)="openNotification()"
    class="content-icon"
  >
    <app-svg-loader url="bell.svg" class="custom-icon"></app-svg-loader>
  </div>

  <!-- User Profile with Dropdown -->
  <div class="profile-section">
    <div
      class="user-avatar"
      (keydown.enter)="profilePanel.toggle($event)"
      (click)="profilePanel.toggle($event)"
      tabindex="0"
    >
      <span class="user-initials">{{ userInitials }}</span>
    </div>
    <div class="user-info">
      <span class="user-name">{{ userData?.name }}</span>
      <span class="user-role">{{ userData?.role }}</span>
    </div>

    <p-popover #profilePanel>
      <div class="profile-dropdown">
        <a
          (click)="onSettingClick()"
          role="menuitem"
          class="dropdown-menu-item"
        >
          <app-svg-loader url="option.svg" class="dropdown-icon"></app-svg-loader>
          <span>Setting</span>
        </a>

        <div
          (click)="logout()"
          tabindex="0"
          (keydown.enter)="logout()"
          role="menuitem"
          class="dropdown-menu-item logout-item"
        >
          <app-svg-loader url="logout.svg" class="dropdown-icon"></app-svg-loader>
          <span>Logout</span>
        </div>
      </div>
    </p-popover>
  </div>
</div>
